import React from 'react';

function Complaints(props) {
  const myLists = props.complaintsJson;  
  const listItems = myLists.map((myList) =>  
    <li key={myList.id} className="Array-item">
      <div className='title'>
        <b>سریال:</b><b>{myList.serial_number}</b>
      </div>
      <div className='date'>
          {myList.created_at_fa}
      </div>
      <div className='describe'>
          <b>وضعیت:</b> {myList.status_text}
      </div>
    </li>
  );  
  return (  
    <div className="w-100 body-padding">
          <p className='wp-header'>شکایات ثبت شده</p>  
          <ul className='Array p-0 mb-5'>{
            (listItems.length === 0) ? <li className='Array-item'><div className='title'>هنوز شکایتی توسط شما ثبت نشده است.</div></li> : listItems
          }
          </ul>
          <button onClick={props.toggleModal} className="btn dina-btn-orange wp-button-add-complaint"><span>+</span></button>
    </div>
  );  
}

export default Complaints;